import { Fragment } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import PropTypes from "prop-types";

const Modal = ({ open, onClose, title, subtitle, icon, children, ctaBtns }) => {
  const IconComponent = icon ? icon : null;

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-700 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all my-20 w-full sm:max-w-lg">
                <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                  <div className="sm:flex sm:items-start">
                    {icon && (
                      <div
                      className="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-artfulRed-100 sm:mx-0 sm:h-10 sm:w-10">
                      <IconComponent className="h-6 w-6 text-artfulRed" aria-hidden="true"/>
                    </div>
                    )}
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title as="h3" className="text-lg font-medium leading-6 text-gray-900">
                        { title }
                      </Dialog.Title>

                      {subtitle && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            {subtitle}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="my-2">
                    { children }
                  </div>
                </div>

                <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                  {ctaBtns?.primary && (
                    <button
                      type="button"
                      className="inline-flex w-full justify-center rounded-md border border-transparent bg-artfulRed px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-artfulRed-dark focus:outline-none focus:ring-2 focus:ring-artfulRed-550 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={ctaBtns.primary.onClick}
                    >
                      {ctaBtns.primary.text}
                    </button>
                  )}

                  {ctaBtns?.secondary && (
                    <button
                      type="button"
                      className="mt-3 inline-flex w-full justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-artfulRed-550 focus:ring-offset-2 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={ctaBtns.secondary.onClick}
                    >
                      {ctaBtns.secondary.text}
                    </button>
                  )}
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
};

Modal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  icon: PropTypes.object,
  children: PropTypes.element,
  ctaBtns: PropTypes.object,
};

export default Modal;
